import { useEffect, useState } from "react";

// Floating "back to top" button. Appears only after the user scrolls down
// past a threshold (stays out of the way on short transcripts), then smooth-
// scrolls back to the top. A long conversation otherwise has to be
// scrolled all the way back up by hand. Pinned to the bottom-end corner.
//
// The scroll container is main.page, NOT the window: the app shell is
// viewport-bound (global.css .app { height: 100%; overflow: hidden }) so
// the window never scrolls — main.page (overflow-y: auto) does.
export function BackToTop({ threshold = 400 }: { threshold?: number }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const scroller = document.querySelector("main.page");
    if (!scroller) return;
    const onScroll = () => setVisible(scroller.scrollTop > threshold);
    onScroll(); // sync initial state (e.g. when navigating in already scrolled)
    scroller.addEventListener("scroll", onScroll, { passive: true });
    return () => scroller.removeEventListener("scroll", onScroll);
  }, [threshold]);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() =>
        document.querySelector("main.page")?.scrollTo({ top: 0, behavior: "smooth" })
      }
      aria-label="Back to top"
      title="Back to top"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 50,
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "1px solid var(--border)",
        background: "var(--surface, #181b24)",
        color: "var(--text, #f9fafb)",
        cursor: "pointer",
        fontSize: 18,
        lineHeight: 1,
        boxShadow: "0 2px 8px rgba(0,0,0,0.35)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      ↑
    </button>
  );
}
